const initialState = {
  testsList: [],
};

export const invoiceReconciliationReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "invoice-reconciliation")
    return action.execute(state);
  return state;
};
